<template>
  <main id="canvas" class="w-auto relative" style="height:12000px">
    <!-- BACKGROUND IMAGES WILL STACK HERE  -->
    <img
      id="pic1"
      style="position: fixed; top:0; left: 0; width:100%; height: auto; opacity: 0; z-index:-1"
      src="https://upload.wikimedia.org/wikipedia/commons/1/1b/0000140_-_Wat_Arun_Ratchawararam_005.jpg"
    />
    <div class="flex flex-col items-center justify-center">
      <div class="text-lg font-semibold text-blue-700 mt-24 uppercase">
        Scroll to begin the narrative!
      </div>

      <!-- DOWNWARD ARROW -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        class="h-12 text-blue-700"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M16 17l-4 4m0 0l-4-4m4 4V3"
        />
      </svg>
      <!-- END DOWNWARD ARROW -->
    </div>

    <div class="tick"></div>
    <div class="tick"></div>

    <div class="tick"></div>
    <div class="tick"></div>

    <div id="t-0" class="h-1 w-1 inline-block border-gray">—</div>

    <div class="tick"></div>
    <div class="tick"></div>

    <div id="t-1">
      <title-element
        id="t-x"
        class="scale-50"
        :options="options"
      ></title-element>
    </div>

    <div class="tick"></div>
    <div class="tick"></div>

    <div class="w-1/3 ml-24" id="p-1">
      <span id="t-3" class="text-white text-lg ml-14">
        Wat Arun is a Buddhist temple in Bangkok, Thailand. The temple derives
        its name from the Hindu god Aruna. This photograph shows the sculptures
        of two mythical giant demons, Thotsakan (green-skinned) and Sahatsadecha
        (white-skinned), guarding the eastern gate of the temple's ordination
        hall, a building designated for the performance of upasampadā, the
        Buddhist ordination ritual, and other ritual ceremonies. The entrance of
        the ordination hall has a roof with a central spire, decorated in
        coloured ceramic and stucco and sheathed in coloured china.
      </span>
    </div>
  </main>
</template>

<script>
// import Component from "../component_location"
import Vue from "vue";
import VueScrollmagic from "vue-scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import TitleElement from "@/components/NarrativeElements/TitleElement.vue";

Vue.use(VueScrollmagic, { refreshInterval: 100 });

export default {
  components: { TitleElement },

  props: [],

  data() {
    return {
      options: {
        title: "The Story of Water",
        author: "Matthew J. Lewis, Ph.D.",
        logo: "@/assets/springmatter-logo.png",
        logoClass: "h-8 mt-1",
        titleClass: "text-blue-500 font-semibold text-4xl",
        authorClass: "text-gray-200",
      },
      tick: screen.height / 10,
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {
    const scene = this.$scrollmagic
      .scene({
        triggerElement: "#t-1",
        triggerHook: 0.75,
        duration: 300,
      })
      .setTween("#t-x", 0.5, {
        css: {
          backgroundColor: "none",
          opacity: 1,
          left: "50%",
          // fontSize: "64px",
          scale: 2.5,
        },
      })
      .addIndicators({ name: "TITLE-TRIGGER" });

    const scene2 = this.$scrollmagic
      .scene({
        triggerElement: "#t-0",
        triggerHook: 0.5,
        duration: 300,
      })
      .setTween("body", 0.5, { css: { backgroundColor: "#151515" } })
      .addIndicators({ name: "CANVAS-TRIGGER" });

    const pinScene = this.$scrollmagic
      .scene({
        triggerElement: "#t-1",
        triggerHook: 0.25,
        duration: 500,
      })
      .setPin("#t-1");

    const scene3 = this.$scrollmagic
      .scene({
        triggerElement: "#p-1",
        triggerHook: 0.3,
        duration: 300,
      })
      .setPin("#p-1");

    const imageAppear = this.$scrollmagic
      .scene({
        triggerElement: "#p-1",
        triggerHook: 0.75,
        duration: 300,
      })
      .setTween("#pic1", 0.5, {
        css: { opacity: 1 },
      });

    const backgroundTransition = this.$scrollmagic
      .scene({
        triggerElement: "#p-1",
        triggerHook: 0.75,
        duration: 100,
      })
      .setTween("#canvas", 0.25, {
        css: {
          backgroundImage:
            "url(https://upload.wikimedia.org/wikipedia/commons/1/1b/0000140_-_Wat_Arun_Ratchawararam_005.jpg)",
          backgroundColor: "#151515",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        },
      });

    const backgroundTransition2 = this.$scrollmagic
      .scene({
        triggerElement: "#p-1",
        triggerHook: 0.75,
      })
      .setTween("#canvas", 0.25, {
        css: {
          opacity: 1,
          // backgroundRepeat: 'no-repeat'
        },
      });

    // ADD SCENES TO THE NARRATIVE.
    this.$scrollmagic.addScene(scene);
    this.$scrollmagic.addScene(scene2);
    this.$scrollmagic.addScene(pinScene);
    this.$scrollmagic.addScene(scene3);
    this.$scrollmagic.addScene(imageAppear);
    this.$scrollmagic.addScene(backgroundTransition);
    this.$scrollmagic.addScene(backgroundTransition2);
  },
};
</script>

<style>
.tick {
  height: 200px;
}
</style>
